const model = {
    submitting: false,
    errors: null,
    details: null,
    success: false,
    countries: [],
};

export default model;
